import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

var _this = this;

export default {
  getImgFmt: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(imgCls) {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return vm.$syscfg.K_Request("Y1002010", {
                IMG_CLS: imgCls
              });

            case 2:
              res = _context.sent;

              if (!(res.Code == 0)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", res.Data[0].IMG_FMT);

            case 7:
              throw "获取影像格式失败";

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function getImgFmt(_x) {
      return _ref.apply(this, arguments);
    };
  }()
};


//////////////////
// WEBPACK FOOTER
// ./src/service/common-service.js
// module id = 1623
// module chunks = 2